import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";

import Swal from "sweetalert2";

import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";

export default class AddUser extends Component {
  state = {
    email: "",
    password: "",
    userName: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
  };

  onRegistration = (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);
    urlencoded.append("userName", this.state.userName);
    urlencoded.append("firstName", this.state.firstName);
    urlencoded.append("lastName", this.state.lastName);
    urlencoded.append("mobileNumber", this.state.mobileNumber);
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    // urlencoded.append("institute", this.state.institute);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/user/register", requestOptions)
      .then((response) => response.text())
      .then((result) => {
          Swal.fire("Success", "User added", "success");
          // localStorage.setItem("livelms_auth", result.auth);
          // localStorage.setItem("livelms_login", true);
          // localStorage.setItem("livelms_role", "admin");
          // window.location.href = "#/admin/dashboard";
          window.location.reload();
      })
      .catch((error) =>   Swal.fire("Error", "Incorrect email and password!", "error"));
  };
  onInputChange = (e) => {
    this.setState({[e.target.name]:e.target.value})
  }
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/users">Users</Link> / <b> Add User</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  First Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="First Name"
                  id="inputDefault"
                  value={this.state.firstName}
                  name="firstName"
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Last Name"
                  id="inputDefault"
                  value={this.state.lastName}
                  name="lastName"
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Email Address
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Email Address"
                  id="inputDefault"
                  value={this.state.email}
                  name="email"
                  onChange={this.onInputChange}
                />
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center flex-column">
              <ImagesUploader
                url="http://localhost:9090/notmultiple"
                optimisticPreviews
                multiple={false}
                onLoadEnd={(err) => {
                  if (err) {
                    console.error(err);
                  }
                }}
              />
              <p>Upload profile pic</p>
            </div>
          </div>
          <hr className="m-0" />
          <div>
            <div className="row m-0 mt-3">
              <div className="col-md-6">
                <div class="form-group row">
                  <label
                    class="col-form-label col-4 text-right"
                    for="inputDefault"
                  >
                    Username
                  </label>
                  <input
                    type="text"
                    class="form-control col-8"
                    placeholder="Username"
                    id="inputDefault"
                    value={this.state.userName}
                    name="userName"
                    onChange={this.onInputChange}
                  />
                </div>
                <div class="form-group row">
                  <label
                    class="col-form-label col-4 text-right"
                    for="inputDefault"
                  >
                    Password
                  </label>
                  <input
                    type="text"
                    class="form-control col-8"
                    placeholder="Password"
                    id="inputDefault"
                    value={this.state.password}
                    name="password"
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
            </div>
            {/* <hr className="m-0" /> */}
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              {/* <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Bio
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Short Discription"
                  id="inputDefault"
                />
              </div> */}
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  User Type
                </label>
                <select class="custom-select col-8">
                  <option selected="">Admin</option>
                  <option value="1">Trainer</option>
                  <option value="2">Learner</option>
                </select>
              </div>
              {/* <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Language
                </label>
                <select class="custom-select col-8">
                  <option selected="">English</option>
                  <option value="1">Hindi</option>
                  <option value="2">German</option>
                </select>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Time zone
                </label>
                <select class="custom-select col-8">
                  <option selected="">GMT 1:00 </option>
                  <option value="1">GMT 2:00</option>
                  <option value="2">GMT 3:00</option>
                  <option value="3">GMT 4:00</option>
                </select>
              </div> */}
            </div>
          </div>
          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.onRegistration}> Save</div> or{" "}
            <Link to="/admin/users" className="btn-link">
              Cancel
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
